import React from "react";
import { AdminCertifiedModeEditTemplate } from "themes/administration/certified-mode/pages";
import { AdminCertifiedModeEditViewStore } from "administration/certified-mode/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new AdminCertifiedModeEditViewStore(rootStore, componentProps),
    "adminCertifiedModeEditViewStore"
)
class AdminCertifiedModeEdit extends React.Component {
    render() {
        return <AdminCertifiedModeEditTemplate {...this.props} />;
    }
}

export default AdminCertifiedModeEdit;
